import { render, staticRenderFns } from "./InvitationPage.vue?vue&type=template&id=32abc257"
import script from "./InvitationPage.vue?vue&type=script&lang=js"
export * from "./InvitationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports